import {
  CATEGORY_LABELS,
  LOG_CATEGORY_OPTIONS,
  MODERATION_ACTIONS,
  MODERATION_CONTENT_TYPES,
  MODERATION_INPUT_TYPES
} from '../constants';

const selectCls =
  'h-[34px] border border-[#D2D8DF] rounded-lg px-2.5 text-[13px] text-[#353E4A] bg-white focus:outline-none focus:ring-2 focus:ring-[#FA3F58]/20';
const inputCls =
  'h-[34px] border border-[#D2D8DF] rounded-lg px-3 text-[13px] text-[#353E4A] bg-white focus:outline-none focus:ring-2 focus:ring-[#FA3F58]/20';
const labelCls = 'text-[10px] font-semibold text-[#97A3B5] uppercase tracking-wide';

const Field = ({ label, children }) => (
  <div className="flex flex-col gap-1">
    <label className={labelCls}>{label}</label>
    {children}
  </div>
);

const LogsFilterBar = ({ filters, onChange, onUserIdChange, onClear }) => (
  <div className="bg-white border border-[#D2D8DF] rounded-xl p-4 mb-4">
    <div className="flex flex-wrap gap-3 items-end">
      <Field label="From">
        <input
          type="date"
          value={filters.from}
          max={filters.to || undefined}
          onChange={(e) => onChange('from', e.target.value)}
          className={inputCls}
        />
      </Field>

      <Field label="To">
        <input
          type="date"
          value={filters.to}
          min={filters.from || undefined}
          onChange={(e) => onChange('to', e.target.value)}
          className={inputCls}
        />
      </Field>

      <Field label="Action">
        <select
          value={filters.action}
          onChange={(e) => onChange('action', e.target.value)}
          className={selectCls}
        >
          <option value="all">All actions</option>
          {MODERATION_ACTIONS.map((a) => (
            <option key={a} value={a}>
              {a}
            </option>
          ))}
        </select>
      </Field>

      <Field label="Category">
        <select
          value={filters.category}
          onChange={(e) => onChange('category', e.target.value)}
          className={selectCls}
        >
          <option value="all">All categories</option>
          {LOG_CATEGORY_OPTIONS.map((c) => (
            <option key={c} value={c}>
              {CATEGORY_LABELS[c]}
            </option>
          ))}
        </select>
      </Field>

      <Field label="Content type">
        <select
          value={filters.contentType}
          onChange={(e) => onChange('contentType', e.target.value)}
          className={selectCls}
        >
          <option value="all">All types</option>
          {MODERATION_CONTENT_TYPES.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </Field>

      <Field label="Input">
        <select
          value={filters.inputType}
          onChange={(e) => onChange('inputType', e.target.value)}
          className={selectCls}
        >
          <option value="all">All inputs</option>
          {MODERATION_INPUT_TYPES.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </Field>

      <Field label="User ID">
        <div className="relative flex items-center">
          <input
            type="text"
            value={filters.userId}
            onChange={(e) => onUserIdChange(e.target.value)}
            placeholder="user _id"
            className={`${inputCls} pr-7 w-[190px] font-mono`}
          />
          {filters.userId && (
            <button
              type="button"
              onClick={() => onUserIdChange('')}
              className="absolute right-2 text-[#97A3B5] hover:text-[#353E4A] transition-colors"
              aria-label="Clear user id"
            >
              <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      </Field>

      <div className="flex items-center gap-2 ml-auto">
        <button
          type="button"
          onClick={onClear}
          className="h-[34px] px-4 rounded-lg border border-[#D2D8DF] text-[13px] text-[#5F6F86] font-medium hover:bg-[#F0F2F4] transition-colors"
        >
          Clear filters
        </button>
      </div>
    </div>
  </div>
);

export default LogsFilterBar;
